import { Tooltip } from '@mui/material';
import React from 'react';
import { PureComponent } from 'react';

interface TooltipProps {
  title: string | React.ReactNode;
  disabled: boolean;
  placement: 'top' | 'bottom' | 'left' | 'right';
  children: React.ReactNode;
}

class TooltipBase extends PureComponent<TooltipProps> {
  static defaultProps = {
    disabled: false,
    placement: 'bottom',
  };
  render() {
    const { title, disabled, placement, children, ...rest } = this.props;
    if (disabled || !title) {
      return <>{children}</>;
    }
    return (
      <Tooltip title={title} placement={placement} {...rest}>
        {React.isValidElement(children)
          ? children
          : (null as unknown as React.ReactElement<any, any>)}
      </Tooltip>
    );
  }
}

export default TooltipBase;
